const GuiaClareamento = () => {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#FEFEFE', padding: '20px 16px' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <div style={{
          position: 'relative',
          width: '100%',
          height: 0,
          paddingTop: '141.4286%',
          paddingBottom: 0,
          boxShadow: '0 2px 8px 0 rgba(63,69,81,0.16)',
          marginTop: '1.6em',
          marginBottom: '0.9em',
          overflow: 'hidden',
          borderRadius: '8px',
          willChange: 'transform',
        }}>
          <iframe
            loading="lazy"
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              border: 'none',
              padding: 0,
              margin: 0,
            }}
            src="https://www.canva.com/design/DAG_JeF-K1k/tOvy_u-2d3vwXXOPv3J5Ng/view?embed"
            allowFullScreen
            allow="fullscreen"
            title="Guia de Cuidados com o Clareamento"
          />
        </div>
        <a
          href="https://www.canva.com/design/DAG_JeF-K1k/tOvy_u-2d3vwXXOPv3J5Ng/view?utm_content=DAG_JeF-K1k&utm_campaign=designshare&utm_medium=embeds&utm_source=link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#85BCFF',
            fontSize: '14px',
            fontFamily: "'Inter', sans-serif",
            textDecoration: 'none',
          }}
        >
          Cuidados pós tratamento - Dra. Giovana Portella Gamborgi
        </a>
      </div>
    </div>
  );
};

export default GuiaClareamento;
